import { useEffect, useRef } from 'react'

import { formateDate } from 'utils/formatting/formateDate/formateDate'

import { MessagesType } from '../../types'

import Icon from 'assets/img/searchEngine/avatar_bot.svg'
import s from './Chat.module.scss'

type ChatProps = {
  messages: MessagesType[]
}

export const Chat = ({ messages }: ChatProps) => {
  const ref = useRef<HTMLDivElement>(null)

  const getCurrentDate = () => {
    return formateDate(new Date(), 'DD MMMM')
  }

  useEffect(() => {
    if (ref.current && messages.length) {
      ref.current.scrollTop = ref.current.scrollHeight
    }
  }, [messages])

  return (
    <div className={s.Chat} ref={ref}>
      <div className={s.messageWrap}>
        <div className={s.date}>{getCurrentDate()}</div>
        {messages.map((message, index) => (
          <div key={index} className={`${s.message} ${message.me ? s.messageFromMe : s.messageNotFromMe}`}>
            <p className={s.messageFromMeText}>
              {message.text} <span className={s.time}>{message.answerTime}</span>
            </p>
            {!message.me && (
              <div className={s.iconContainer}>
                <img src={Icon} alt="icon" className={s.icon} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
